import { ElogBillingCode, ElogParticipant } from "@services/meetings/types";
import { getSortOptionsFn } from "../common/Controls";
import { SortDirections, SortObject } from "../common/Controls/types";

export enum SortKeys {
  CODE = "Billing Code",
  QUANTITY = "Quantity",
  ROOM = "Room",
  DESCRIPTION = "Description",
}

export const getSortFn =
  ({ key, direction }: SortObject<SortKeys>) =>
  (
    a: ElogBillingCode | ElogParticipant,
    b: ElogBillingCode | ElogParticipant
  ) => {
    let valueA: string | number, valueB: string | number;
    const sign = direction === SortDirections.ASC ? 1 : -1;
    switch (key) {
      case SortKeys.QUANTITY:
        valueA = a.quantity ?? 0;
        valueB = b.quantity ?? 0;
        return (valueA - valueB) * sign;
      case SortKeys.CODE:
        valueA = a.billingCode ?? "";
        valueB = b.billingCode ?? "";
        break;
      case SortKeys.ROOM:
        valueA = (a as ElogParticipant)?.room?.name ?? "";
        valueB = (b as ElogParticipant)?.room?.name ?? "";
        break;
      case SortKeys.DESCRIPTION:
        valueA = a.description ?? "";
        valueB = b.description ?? "";
        break;
    }

    return valueA.localeCompare(valueB) * sign;
  };

export const getSortOptions = getSortOptionsFn([
  SortKeys.CODE,
  SortKeys.QUANTITY,
  SortKeys.ROOM,
  SortKeys.DESCRIPTION,
]);
